<template>
  <div>
    <label v-html="label" />
    <v-select v-if="options_url" v-model="content" :name="name" :ajax="options_url" :disabled="disabled" :class="classes" :data-tags="tags" :data-fillable="is_fillable" :readonly="readonly">
    </v-select>
    <v-select v-else v-model="content" :name="name" :options="options" :disabled="disabled" :class="classes" :data-tags="tags" :data-fillable="is_fillable" :readonly="readonly">
    </v-select>
    <small class="form-text text-danger">Value is invalid.</small>
  </div>
</template>
<script>
  export default {
    props: [
      'label', 'model', 'options', 'tags', 'options_url',
      'name', 'disabled', 'classes', 'fillable', 'readonly'
    ],
    data: function() {
      return {
        content: this.model
      }
    },
    watch: {
      model (val) {
        if (JSON.stringify(this.model) != JSON.stringify(this.content)) {
          this.content = this.model;
        }
      },
      content (val) {
        this.$emit("update:model", val);
      }
    },
    computed: {
      is_fillable () {
        return this.fillable ? "fillable" : false;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/select.vue